"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const lossfirmnessskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-lossfirmnessskin` : '') + (description ? ` desc-lossfirmnessskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-lossfirmnessskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-lossfirmnessskin"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_26120_2705)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.54 13.69a5.59 5.59 0 0 1 6.28-.4l2.8 1.66a.75.75 0 1 1-.76 1.3l-2.8-1.67a4.09 4.09 0 0 0-4.6.3 5.61 5.61 0 0 1-6.84 0 4.16 4.16 0 0 0-4.7-.25l-2.66 1.64a.75.75 0 1 1-.79-1.28l2.65-1.63a5.66 5.66 0 0 1 6.41.33 4.11 4.11 0 0 0 5.01 0Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.55 9.6a16.9 16.9 0 0 1 1.6.05l.09.01a3.7 3.7 0 0 1 .03 0 .75.75 0 0 1-.1 1.5h-.1l-.07-.01a9.62 9.62 0 0 0-1.43-.06c-.95.01-2.26.1-3.68.44-1.9.45-4.04.83-5.87.83-1.82 0-3.96-.38-5.87-.83a17.07 17.07 0 0 0-5.1-.38H.96a.75.75 0 1 1-.19-1.48h.04l.1-.02a11.67 11.67 0 0 1 1.58-.06c1.04.02 2.46.12 4 .48 1.88.44 3.89.79 5.53.79 1.65 0 3.66-.35 5.53-.79 1.55-.36 2.97-.46 4-.48Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.02.18c.42 0 .75.34.75.75v6.3l2.32-2.32a.75.75 0 0 1 1.06 1.06l-3.59 3.6-.01.01a.74.74 0 0 1-.89.12l-.05-.03h-.01l-.01-.01a.75.75 0 0 1-.09-.08l-.01-.01-3.6-3.6a.75.75 0 1 1 1.07-1.06l2.31 2.32V.93c0-.41.34-.75.75-.75Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.18 21.23a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.99 21.23a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.49 21.23a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.27 21.23a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.18 17.48a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.71 17.48a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.24 17.48a1.1 1.1 0 1 1 0 2.18 1.1 1.1 0 0 1 0-2.18Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_26120_2705"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = lossfirmnessskin;